<template>
    <b-tabs
        class="quest-settings-tab apprentice-pills-tab"
        v-model="currentTab"
        pills
        vertical
        nav-wrapper-class="col-12 col-md-3"
        @input="updateTabIndex"
        :key="quest.id">
        <b-tab
            :title="$t('quest.general')"
            active
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link"
            :key="'Generic'">
            <template v-slot:title> <i class="fa fa-cog"></i> {{ $t('quest.general') }} </template>

            <design-2021-quest-edit-general-component :quest-in="quest"></design-2021-quest-edit-general-component>
        </b-tab>
        <b-tab
            :title="$t('quest.assignments')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link"
            :key="'Assignmnet'">
            <template v-slot:title> <i class="fa fa-rocket"></i> {{ $t('quest.assignments') }} </template>
            <div>
                <design-2021-quest-edit-missions-component
                    :quest-id="quest.id"
                    :levels-in="quest.levels"></design-2021-quest-edit-missions-component>
            </div>
        </b-tab>
        <b-tab
            title="Planning"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link"
            :key="'Planning'">
            <template v-slot:title> <i class="fa fa-clock"></i> Planning </template>
            <div>
                <design-2021-quest-edit-deadlines-component :quest="quest"></design-2021-quest-edit-deadlines-component>
            </div>
        </b-tab>
        <b-tab
            :title="$t('quest.skills')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link"
            :key="'Skills'">
            <template v-slot:title> <i class="fa fa-star"></i> {{ $t('quest.skills') }} </template>
            <div>
                <design-2021-quest-edit-skills-component
                    :quest-id="quest.id"
                    :skills-in="quest.skills"></design-2021-quest-edit-skills-component>
            </div>
        </b-tab>
        <b-tab
            :title="$t('quest.students')"
            title-item-class="settings-tab-item"
            title-link-class="settings-tab-item-link"
            :key="'Students'">
            <template v-slot:title>
                <i
                    class="fa fa-users"
                    style="margin-right: 10px"></i>
                {{ $t('quest.students') }}
            </template>
            <div>
                <design-2021-quest-edit-students-component
                    :groups="groups"
                    :users="users"
                    :quest-id="quest.id"></design-2021-quest-edit-students-component>
            </div>
        </b-tab>
    </b-tabs>
</template>

<script>
export default {
    name: 'design-2021-quest-settings-component',
    props: ['quest', 'group', 'users', 'groups'],

    data() {
        return {
            currentTab: 0,
            localStorageTitle: 'lorimIpsum',
        };
    },

    methods: {
        updateTabIndex(tabIndex) {
            this.currentTab = tabIndex;
            localStorage.setItem(this.localStorageTitle, tabIndex);
        },
    },

    created() {
        if (localStorage.getItem(this.localStorageTitle)) {
            this.currentTab = parseInt(localStorage.getItem(this.localStorageTitle));
        }
    },
};
</script>

<style scoped>
.group-options-table >>> .thead-dark >>> tr >>> th {
    background-color: #e8eff4;
    border-color: #e8eff4;
}
</style>
